import moment from 'moment';
import 'moment-timezone';

export const convertDateToSelectedTimeZone = (date: any) => {
  const getFacilityTimeZone = localStorage.getItem('facility_timezone') || '';
  if (!getFacilityTimeZone) return date;
  return (typeof date === 'string' ? new Date(date) : date)?.toLocaleString('en-US', {
    timeZone: getFacilityTimeZone,
  });
};

export const getTimeZoneOffset = (timeZone: string) => {
  const date = new Date();
  const timeZoneFormat = new Intl.DateTimeFormat('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    timeZone,
  });
  const [{ value: hours }, , { value: minutes }] = timeZoneFormat.formatToParts(date);
  const offsetString = `${hours}:${minutes}`;
  return offsetString;
};

export const convertDateToFacilityDate = (date: any) => {
  const getFacilityTimeZone = localStorage.getItem('facility_timezone') || '';
  if (!getFacilityTimeZone) {
    console.warn('No facility time zone found. Returning the original date.');
    return date;
  }

  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj)) {
      console.error('Invalid date provided:', date);
      return date;
    }
    // @ts-ignore
    const formattedDate = moment.tz(dateObj, getFacilityTimeZone).format();
    return formattedDate;
  } catch (error) {
    console.error('Error converting date:', error);
    return date;
  }
};

export function formatDateWithTimezone(dateString: any) {
  const getFacilityTimeZone = localStorage.getItem('facility_timezone') || '';
  const originalDate = moment(dateString, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');

  const formattedDate = originalDate
    .clone()
    .tz(getFacilityTimeZone, true)
    .format('YYYY-MM-DDTHH:mm:ssZ');

  return formattedDate;
}

export function formatDateWithTimezoneWithZeroSecond(dateString: any) {
  const getFacilityTimeZone = localStorage.getItem('facility_timezone') || '';
  const originalDate = moment(dateString, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ').second(0);

  const formattedDate = originalDate
    .clone()
    .tz(getFacilityTimeZone, true)
    .format('YYYY-MM-DDTHH:mm:ssZ');

  return formattedDate;
}

export const convertIntoIsoFormat = (formattedDate: any) => {
  if (typeof formattedDate === 'string') {
    return formattedDate.replace(/([+-]\d{2}:\d{2}|Z)$/, '.000Z');
  } else {
    // Handle the case where formattedDate is not a string
    console.error('Invalid date format:', formattedDate);
    return null; // or you can return a default value if you prefer
  }
};
export const toISOWithOffset = (dateString: any) => {
  // Create a new Date object
  const date = new Date(dateString);

  // Extract components
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Get the timezone offset in minutes
  const offset = date.getTimezoneOffset();
  const offsetSign = offset > 0 ? '-' : '+';
  const offsetHours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
  const offsetMinutes = String(Math.abs(offset) % 60).padStart(2, '0');

  // Format the offset
  const timezoneOffset = `${offsetSign}${offsetHours}:${offsetMinutes}`;

  // Construct the ISO format string
  const isoString = `${year}-${month}-${day}T00:00:00${timezoneOffset}`;

  return isoString;
};